/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GoodsPassThruFleetApiModel {
  /**
   * Unit of measure
   */
  measure_unit?: GoodsPassThruFleetApiModelMeasureUnitEnum | null;
  /**
   * NACS Product Code
   */
  product_code?: string | null;
}
export enum GoodsPassThruFleetApiModelMeasureUnitEnum {
  L = 'L',
  G = 'G'
}
